[{
  "label": "Engage Admins", "icon": "pi pi-fw pi-home", "root": true, "expanded": true,
  "items": [
    { "label": "Dashboard", "icon": "pi pi-fw pi-home", "routerLink": ["dashboard"] },
    { "label": "Tenants", "class": "fa-solid fa-building-user custom-icon","routerLink": ["admin/tenants/list"] },
    { "label": "Admin Users",
      "icon": "pi pi-fw pi-users",
      "routerLink": [
        "admin/admin-users/list"
      ]
    },
    { "label": "Menus", "class": "fa-solid fa-list-dropdown custom-icon","routerLink": ["admin/menus"] }

  ]
}
]
